import { IPeerAssessment, IPeerAssesssmentItem, IPeerAssessmentData, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const peerAssessmentsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_peerAssessments: builder.query<ITableRes<IPeerAssesssmentItem>, {id: string, params?: any}>({
      query: ({id, params}) => ({
        url: `/submissions/${id}/peer-assessments/`,
        params,
      }),
      providesTags: ['peer-assessments'],
    }),
    GET_submissionsForPeerAssessment: builder.query<ITableRes<IPeerAssessment>, {id: string}>({
      query: ({id}) => ({
        url: `/submissions-for-peer-assessment/${id}/`,
      }),
      providesTags: ['peer-assessments'],
    }),
    POST_assessPeerSubmission: builder.mutation<IPeerAssessment, {id: string, body: IPeerAssessmentData}>({
      query: ({id, body}) => ({
        url: `/assess-peer-submission/${id}/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['peer-assessments'],
    }),
  }),
})

export const {
  useGET_peerAssessmentsQuery,
  useGET_submissionsForPeerAssessmentQuery,
  usePOST_assessPeerSubmissionMutation,
} = peerAssessmentsAPI
